import axios from 'axios';

const getAvaliacoes = (params) => axios.get('/avalicao-compra', { params });

export default {
  getAvaliacoes,
};
